import React from "react";

export const DropdownArrow: React.FC<{ rotated: boolean }> = (props) => (
  <div>
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginLeft: "2em",
        transform: `rotate(${props.rotated ? 180 : 0}deg)`,
      }}
    >
      <path
        d="M7.20681 0.929688H0.792743C0.60036 0.929688 0.492938 1.13281 0.612078 1.27148L3.81911 4.99023C3.91091 5.09668 4.08766 5.09668 4.18044 4.99023L7.38747 1.27148C7.50661 1.13281 7.39919 0.929688 7.20681 0.929688Z"
        fill="#2ECBCA"
      />
    </svg>
  </div>
);
